import { useCallback, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import {
  AuthenticationStatus,
  logout,
  setAuthStatusPleb,
  setCurrentUserId
} from '../store/slices/authSlice';
import mixpanel from '../utils/MixPanel';
import { Credentials } from '../models/Credentials';
import { Pleb } from '../models/Pleb';

export function useAuth() {
  const dispatch = useDispatch<AppDispatch>();
  const auth = useSelector((state: RootState) => state.auth);

  const logoutAction = useCallback(async () => {
    mixpanel.track('WebApp - logout');
    dispatch(logout(auth.currentUserId ?? ''));
  }, [dispatch, auth.currentUserId]);

  const pleb = useMemo(() => {
    return auth.currentUserId ? auth.users[auth.currentUserId] : null;
  }, [auth.users, auth.currentUserId]);

  const tokens = useMemo(() => {
    return auth.currentUserId ? auth.tokens[auth.currentUserId] : null;
  }, [auth.tokens, auth.currentUserId]);

  const setCredentialsOnLogin = useCallback((credentials: Credentials, pleb: Pleb) => {
    dispatch(setAuthStatusPleb({
      status: AuthenticationStatus.INITIAL,
      pleb: pleb?.toJson() ?? null,
      tokens: credentials
    }));
  }, [dispatch, tokens]);

  const updateCurrentPleb = useCallback((pleb: Pleb) => {
    dispatch(setAuthStatusPleb({
      pleb: pleb?.toJson() ?? null,
    }));
  }, [dispatch, tokens]);

  return {
    status: auth.status,
    currentUserId: auth.currentUserId,
    pleb: pleb,
    users: auth.users,
    tokens: tokens,
    logout: logoutAction,
    setCredentialsOnLogin: setCredentialsOnLogin,
    updateCurrentPleb: updateCurrentPleb,
    setCurrentUserId: useCallback((data: string) => 
      dispatch(setCurrentUserId(data)), [dispatch]),
  };
} 
